<div class="input-container" [ngClass]="{error: error}">
  <input [type]="type" [attr.name]="name || formControlName" [(ngModel)]="value" [placeholder]="placeholder ? placeholder : ''" [disabled]="disabled" [maxlength]="maxlength" [mask]="mask" [leadZeroDateTime]="mask ? true : undefined">
  <span class="error-message">{{error}}</span>
</div>
